import { Component } from '@angular/core';

@Component({
  selector: 'app-garantieregeling',
  standalone: false,
  templateUrl: './garantieregeling.component.html',
  styleUrls: ['./garantieregeling.component.scss']
})
export class GarantieregelingComponent {}